import React from "react";

export const Container = ({ className = "", children, ...rest }) => (
  <div
    className={`max-w-[1200px] mx-auto px-6 md:px-10 ${className}`}
    {...rest}
  >
    {children}
  </div>
);

export default Container;
